module.exports = __webpack_public_path__ + "static/img/failed.0b10dd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bargain/failed.png
// module id = dhaP
// module chunks = 1